import { MenuItem, MenuHeading } from '@kasasa/fbase-components/lib';

const menuItems: (MenuItem | MenuHeading)[] = [
	{ icon: '', label: 'Do Not Email', to: '/do-not-email' }
];

export default menuItems;
